import { queryOptions } from '@tanstack/react-query'
import { apiGet, unwrap } from '@/shared/api'
import { type EmployeeOverview, EmployeeOverviewSchema } from '../model/overview'
import { employeeKeys } from './queries'

interface FocusStatusDto {
  started_at: string
}

interface RunningTimerDto {
  task_id: string
  task_title: string
  board_id: string
  started_at: string
}

interface ActiveTaskDto {
  task_id: string
  title: string
  board_id: string
  board_name: string
  project_name: string
}

export interface EmployeeOverviewDto {
  employee_id: string
  name: string
  departments?: string[]
  total_seconds: number
  today_seconds: number
  focus?: FocusStatusDto
  timer?: RunningTimerDto
  active_count: number
  active_tasks: ActiveTaskDto[]
  completed_count: number
}

export function toEmployeeOverview(dto: EmployeeOverviewDto): EmployeeOverview {
  return EmployeeOverviewSchema.parse({
    employeeId: dto.employee_id,
    name: dto.name,
    departments: dto.departments ?? [],
    totalSeconds: dto.total_seconds,
    todaySeconds: dto.today_seconds,
    focus: dto.focus ? { startedAt: dto.focus.started_at } : null,
    timer: dto.timer
      ? {
          taskId: dto.timer.task_id,
          taskTitle: dto.timer.task_title,
          boardId: dto.timer.board_id,
          startedAt: dto.timer.started_at,
        }
      : null,
    activeCount: dto.active_count,
    activeTasks: (dto.active_tasks ?? []).map((t) => ({
      taskId: t.task_id,
      title: t.title,
      boardId: t.board_id,
      boardName: t.board_name,
      projectName: t.project_name,
    })),
    completedCount: dto.completed_count,
  })
}

// Сводка по всем сотрудникам (раздел «Сотрудники»). Live-данные — поллинг 30с,
// как у прочих presence/счётчиков.
export const employeesOverviewQueryOptions = queryOptions({
  queryKey: employeeKeys.overview(),
  queryFn: async (): Promise<EmployeeOverview[]> => {
    const list = unwrap<EmployeeOverviewDto[]>(await apiGet('/employees/overview')) ?? []
    return list.map(toEmployeeOverview)
  },
  refetchInterval: 30_000,
})
